export const TABLE_ROW_HEIGHT = 48;
export const TABLE_HEADER_HEIGHT = 52;
